import Axios from "axios"
import { orderBy } from "lodash"
import { API_ADMIN } from "../../utils/constants/Api"
import { IFilterList } from "../../utils/interfaces/FilterListInterface"
import { SubscriberForgottenWrapperModel } from "../models/SubscriberForgottenWrapperModel"
import { SubscriberModel } from "../models/SubscriberModel"

interface SubscriberForgottenWrapperModelWrapped {
    lastUpdate: string;
    list: SubscriberForgottenWrapperModel[];
}

export default {
    getSubscriberList(page:number, filter: IFilterList):Promise<SubscriberModel[]> {
        return Axios.get(`${API_ADMIN}subscribers?page=${page}${filter.toPartialQueryString()}`)
            .then(({data}) => {
                return orderBy(data.map((s:SubscriberModel) => new SubscriberModel(s)), ['name'], ['asc'])
            })
    },
    getNonPayingSubscriberList():Promise<SubscriberForgottenWrapperModelWrapped> {
        return Axios.get(`${API_ADMIN}subscribers/non_paying?force=false`)
            .then(({data}) => {
                return {
                    lastUpdate: data.lastUpdate,
                    list: orderBy(data.list.map((s:SubscriberForgottenWrapperModel) => new SubscriberForgottenWrapperModel(s)), ['subscriber.days'], ['desc']),
                }
            })
    },
    invalidateNonPayingSubscriberListCache():Promise<any> {
        return Axios.get(`${API_ADMIN}subscribers/non_paying?force=true`)
    },
    getSubscriberById(id:string):Promise<SubscriberModel> {
        return Axios.get(`${API_ADMIN}subscribers/${id}`)
            .then(({data}) => {
                return new SubscriberModel(data)
            })
    },
    enableBilling(idSubscriber: number, idProduct: number):Promise<SubscriberModel> {
        return Axios.patch(`${API_ADMIN}subscribers/${idSubscriber}/products/${idProduct}/billing/enable`)
            .then(({data}) => {
                return new SubscriberModel(data)
            })
    },
    disableBilling(idSubscriber: number, idProduct: number):Promise<SubscriberModel> {
        return Axios.patch(`${API_ADMIN}subscribers/${idSubscriber}/products/${idProduct}/billing/disable`)
            .then(({data}) => {
                return new SubscriberModel(data)
            })
    },
}
